var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EHPADFirstPartComp',{attrs:{"mobile":_vm.mobile}}),_c('CommonEstablishmentsComp',{attrs:{"mobile":_vm.mobile}}),_c('EHPADSecondPartComp',{attrs:{"mobile":_vm.mobile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }